import { Info } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function UserAbortConfirmation() {
  const { t } = useTranslation('prince');

  return (
    <div className="flex">
      <div className="mt-3 p-3 bg-blue-50 border border-blue-200 rounded-lg flex items-center gap-2 text-blue-700">
        <Info className="h-4 w-4" />
        <span className="text-sm font-medium">{t('messages.userAbortConfirmation')}</span>
      </div>
    </div>
  );
}
